import React, { useState } from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import { Input, Button, Pill } from '@trexity/common-client/lib/components'

const Mailchimp = () => {
  const [email, setEmail] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [requestSent, setRequestSent] = useState(false)
  const [sendingRequest, setSendingRequest] = useState(false)

  const sendToMailchimp = async () => {
    setSendingRequest(true)
    const result = await addToMailchimp(email)

    if (result) {
      // success
      setSendingRequest(false)
      setRequestSent(true)
      setSuccessMessage('Submitted. Thanks for your interest.')
      setErrorMessage('')
    } else {
      // failure
      setSendingRequest(false)
      setErrorMessage('Try again, or reach out to info@trexity.com')
    }
  }

  return (
    <div id="newsletter-signup">
      <div id='mailchimp'>
        <Input
          value=''
          label="Email"
          disabled={requestSent}
          onChange={(evt) => setEmail(evt.target.value)}
          style={{ borderRadius: 0 }}
        />
        <Button
          bg="#4351ee"
          onClick={() => { sendToMailchimp() }}
          disableAnimations
          loading={sendingRequest}
          disabled={requestSent}
          style={{ width: 140, borderRadius: 0 }}
        >{requestSent ? 'Submitted' : 'Subscribe'}</Button>
      </div>
      <div className="contact-status" style={{ marginTop: 20 }}>
        {successMessage ? <Pill label={successMessage} light type="Base" /> : null}
        {errorMessage ? <Pill label={errorMessage} light type="Cancel" /> : null}
      </div>
    </div>
  )
}

export default Mailchimp
